import axios from 'axios';

const state = {};

const getters = {};
const headersDash = {
  // withCredentials: true,
  // live
  // 'api-key-id': '418682ed-8cad-4ee2-915a-fb1f405a5eda',
  // 'api-key-secret': '$2a$10$cr9TwxjcEg6apUg9s6Xj0u0gCMQl0wjgtXMoo.Y9yhU.8w97e3xNW',
  'api-key-id': 'cc4cdff2-1b10-4f9f-9e25-9f3105368b71',
  'api-key-secret': '2e52dcc1d17e56e8ffdb1ad6adc72e448118d7575d95e85aff0d974bba9d602b',
  // staging
  // "api-key-id": "bbfe1699-1a0b-4d06-8121-5e05f9ca581c",
  // "api-key-secret": "$2a$10$hcWFZQW7Mx3pUlS0YJc5oegyJckEg1yjUqQK8oACcoz7udSM3P0xe"
};

const actions = {
  async fetchData(context, params) {
    const query = params.query ? `&${params.query}` : ' ';
    const response = await axios.post(
      `https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/${params.datasetGUID}/latest/urql?limit(-1)${query}`,
      {
        data: { iframe: true },
      },
      { headers: headersDash },
    );
    // const response = await axios.post(
    //   `http://localhost:8083/org/28ccd497-7cad-4470-bd17-721d5cbbd6ef/${params.datasetGUID}/latest/urql?limit(-1)${query}`,
    //   {
    //     headers: headersDash,
    //     data: { iframe: true },
    //   },
    // );
    return response;
  },
  async fetchStagingData(context, params) {
    const query = params.query ? `&${params.query}` : ' ';
    const response = await axios.post(
      `https://api-staging.usmart.io/org/28ccd497-7cad-4470-bd17-721d5cbbd6ef/27d4e9f7-7419-4dfc-9231-039e3cd50595/latest/urql?limit(-1)${query}`,
      {
        headers: headersDash,
        data: { iframe: true },
      },
    );
    return response;
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
